export const isRequired = (message: string, minLength = 1) => {
    return {
        required: {
            value: true,
            message: message
        },
        validate: (value: string) => (!!value && value.length >= minLength) || message
    };
};

export const isRequiredNumber = (message: string, minLength = 1) => {
    return {
        required: {
            value: true,
            message: message,
        },
        //valueAsNumber: true,
        validate: (value: number | string) => {
            let isValid = Number.isInteger(value) || !isNaN(parseInt(value.toString()));
            isValid = isValid && value.toString().length >= minLength;
            return isValid || message
        },
        setValueAs: (value: number | string | undefined) => {
            if (!value || Number.isInteger(value)) {
                return value;
            }

            const stringValue = value.toString();
            return stringValue === "" ? undefined : parseInt(stringValue);
        }
    }
};

export const isRequiredNumberString = (message: string, minLength = 1) => {
    return {
        required: {
            value: true,
            message: message,
        },
        validate: (value: string) => {
            if (!value) {
                return false;
            }
            let isValid = Number.isInteger(value) || !isNaN(parseInt(value.toString()));
            isValid = isValid && value.length >= minLength;
            return isValid || message
        },
        setValueAs: (value: string | undefined) => {
            return value ?? "";
        }
    }
};

export default { isRequired, isRequiredNumber, isRequiredNumberString };